import { Alert, Button, Col, DatePicker, Form, Input, Modal, Row, Table, TimePicker, Tooltip, Select, Radio, Descriptions, List, Divider, Avatar, Space } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import dayjs from 'dayjs';

function Meeting() {
    const token = useSelector((state) => state.user.token);
    const user = useSelector((state) => state.user.user);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: { current: 1, pageSize: 10 },
        sorter: { order: 'desc', columnKey: 'meeting_schedule_id' }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [mode, setMode] = useState("division");
    // list divisi & user buat select
    const [divisions, setDivisions] = useState([]);
    const [users, setUsers] = useState([]);
    const [locations, setLocations] = useState([]);
    const [isDetailModal, setIsDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);

    const titlePage = 'Meeting Schedule';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Users',
            dataIndex: 'users',
            key: "users",
            render: (users) => users ? users.name : '-'
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: "location",
            sorter: true,
        },
        {
            title: 'Purpose',
            dataIndex: 'description',
            key: "description",
            sorter: true,
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: "date",
            sorter: true,
            render: (text, record) => moment(record.date).format('DD-MM-YYYY')
        },
        {
            title: 'Start Time',
            dataIndex: 'time_start',
            key: "time_start",
            sorter: true,
        },
        {
            title: 'End Time',
            dataIndex: 'time_end',
            key: "time_end",
            sorter: true,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                const usr = JSON.parse(user);
                if (usr.users_id === record.users_id)
                    return (
                        <>
                            <Tooltip title="Detail">
                                <Button style={{ marginRight: 10 }} onClick={() => openModal('detail', record)}>
                                    <UnorderedListOutlined />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Edit">
                                <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                                    <EditOutlined />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                                    <DeleteOutlined />
                                </Button>
                            </Tooltip>
                        </>
                    );
                else return (
                    <Tooltip title="Detail">
                        <Button style={{ marginRight: 10 }} onClick={() => openModal('detail', record)}>
                            <UnorderedListOutlined />
                        </Button>
                    </Tooltip>);
            },
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'meeting_schedule_id';
        getApi("GET", `/meeting?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'meeting');

        // load dropdown data
        getApi("GET", "/division?nopage=true", "division");
        getApi("GET", "/selectusers?nopage=true", "users");
        getApi("GET", "/availablemeetinglocation", "locations");
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: { headers: { Authorization: 'Bearer ' + token } }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                if (type === "meeting") {
                    setData(res.data.data);
                    setPage(prev => ({
                        ...prev,
                        pagination: { ...prev.pagination, total: res.data.total_data }
                    }));
                } else if (type === "division") {
                    setDivisions(res.data.data);
                } else if (type === "users") {
                    setUsers(res.data.data);
                } else if (type === "locations") {
                    setLocations(res.data);
                }
            }
            setLoading(false);
        }).catch(e => {
            console.error(e.message);
            setLoading(false);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch(e => {
            console.error(e.message);
            setLoading(false);
        });
    };

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this entry?',
            onOk: () => postApi('DELETE', '/meeting/' + record.meeting_schedule_id, null),
        });
    };

    const openModal = async (type, data) => {
        if (type === "add") {
            setdataModal(null);
            setMode("division"); // default add mode
            form.resetFields();
            setIsModal(true);
        }

        if (type === "edit") {
            setdataModal(data);
            var op = {
                meeting_location_id: data.meeting_location_id,
                name: data.meeting_location.name,
                status: 'add'
            }
            setLocations([...locations, op]);

            // tentukan mode otomatis
            if (data.division_id) {
                setMode("division");
            } else {
                setMode("user");
            }
            form.setFieldsValue({
                division_id: data.division_id || null,
                users_id: data.user_meeting?.map((u) => u.users_id) || [],
                meeting_location_id: data.meeting_location_id,
                description: data.description,
                date: dayjs(data.date),
                time_start: dayjs(data.time_start, "HH:mm:ss"),
                time_end: dayjs(data.time_end, "HH:mm:ss"),
            });
            setIsModal(true);
        }

        if (type === "detail") {
            try {
                const res = await apiCall({
                    method: "GET",
                    url: `/meeting/${data.meeting_schedule_id}`,
                    data: { headers: { Authorization: "Bearer " + token } },
                });

                if (res.status === "success") {
                    setDetailData(res.data);
                    setIsDetailModal(true);
                } else {
                    modalError(res.message);
                }
            } catch (e) {
                console.error(e);
            }
        }
    };

    const onFinish = (values) => {
        if (mode === "division") {
            values.users_id = []; // kosongkan users kalau division
        } else {
            values.division_id = null;
        }

        if (!values.division_id && (!values.users_id || values.users_id.length === 0)) {
            modalError("Select one: Division or User");
            return;
        }

        values.time_start = values.time_start.format("HH:mm:ss");
        values.time_end = values.time_end.format("HH:mm:ss");
        values.date = values.date.format("YYYY-MM-DD");
        if (dataModal != null) {
            postApi("PUT", "/meeting/" + dataModal.meeting_schedule_id, values);
        } else {
            postApi("POST", "/meeting", values);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);

        setMode("division"); // reset ke default
        setLocations((prev) => prev.filter((loc) => loc.status !== "add"));
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter: {
                columnKey: sorter.columnKey,
                order: sorter.order,
            },
        });
        if (pagination.pageSize !== page.pagination?.pageSize) setData([]);
    };


    const searchData = (value) => {
        setSearch(value);
        setPage({ pagination: { current: 1, pageSize: 10 } });
    };

    const closeDetailModal = () => {
        setDetailData(null);
        setIsDetailModal(false);
    };

    return (
        <div>
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Meeting Schedule</h3>
            <Row>
                <Col span={8}>
                    <Search placeholder="Search" allowClear enterButton="Search" size="middle" onSearch={searchData} />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined /> <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="meeting_schedule_id"
            />
            <Modal title="Meeting Data" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>

                    <Form.Item label="Select Mode">
                        <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
                            <Radio value="division">Division</Radio>
                            <Radio value="user">User</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {mode === "division" && (
                        <Form.Item
                            label="Division"
                            name="division_id"
                            rules={[{ required: true, message: "Select division" }]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={divisions.map((d) => ({
                                    label: d.name,
                                    value: d.division_id,
                                }))}
                            />
                        </Form.Item>
                    )}

                    {mode === "user" && (
                        <Form.Item
                            label="Users"
                            name="users_id"
                            rules={[{ required: true, message: "Select at least one user" }]}
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                optionFilterProp="label"
                                options={users.map((u) => ({
                                    label: u.name,
                                    value: u.users_id,
                                }))}
                            />
                        </Form.Item>
                    )}

                    <Form.Item name="meeting_location_id" label="Location" rules={[{ required: true, message: 'Location is required!' }]}>
                        <Select
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                            options={locations.map(l => ({ label: l.name, value: l.meeting_location_id }))}
                        />
                    </Form.Item>
                    <Form.Item name="description" label="Purpose / Description" rules={[{ required: true, message: 'Purpose is required!' }]}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item name="date" label="Date" rules={[{ required: true, message: 'Date is required!' }]}>
                        <DatePicker />
                    </Form.Item>
                    <Form.Item name="time_start" label="Start Time" rules={[{ required: true, message: 'Start Time is required!' }]}>
                        <TimePicker />
                    </Form.Item>
                    <Form.Item name="time_end" label="End Time" rules={[{ required: true, message: 'End Time is required!' }]}>
                        <TimePicker />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                open={isDetailModal}
                onCancel={closeDetailModal}
                footer={null}
                title="Detail Meeting"
                width={700}
            >
                {detailData && (
                    <>
                        <Descriptions column={2} bordered size="small">
                            <Descriptions.Item label="Pembuat" span={2}>
                                <Space>
                                    <Avatar src={detailData.users?.image} />
                                    {detailData.users?.name} ({detailData.users?.users_code})
                                </Space>
                            </Descriptions.Item>
                            <Descriptions.Item label="Divisi" span={1}>
                                {detailData.divisi || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Lokasi Meeting" span={1}>
                                {detailData.meeting_location?.name} ({detailData.meeting_location?.address})
                            </Descriptions.Item>
                            <Descriptions.Item label="Tanggal" span={1}>
                                {dayjs(detailData.date).format("DD MMM YYYY")}
                            </Descriptions.Item>
                            <Descriptions.Item label="Waktu" span={1}>
                                {detailData.time_start} - {detailData.time_end}
                            </Descriptions.Item>
                            <Descriptions.Item label="Deskripsi" span={2}>
                                {detailData.description || "-"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <h4>Peserta</h4>
                        <List
                            itemLayout="horizontal"
                            dataSource={detailData.user_meeting || []}
                            renderItem={(item) => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Avatar src={item.users?.image} />}
                                        title={`${item.users?.name}`}
                                        description={`${item.users?.users_code || "-"}`}
                                    />
                                </List.Item>
                            )}
                        />
                    </>
                )}
            </Modal>

        </div>
    );
}

export default Meeting;
